export const LOCALE = {
  "ja-JP": {
    pathType: {
      general: "コア レッスン",
      listening: "リスニング",
      speaking: "会話",
      pronunciation: "発音",
      reading: "読解",
      early_reading: "読解",
      writing: "ライティング",
      grammar: "文法",
      parrot_milestone: "マイルストーン",
      production_milestone: "マイルストーン",
      review: "復習",
      lagged_review: "Adaptive Recall",
      vocabulary: "語彙",
      listening_and_reading: "リスニングと読解",
      eschool: "ライブ コーチ",
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixin/locales.js